// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__eXDtw","title":"styles_title__W7Khh","content":"styles_content__mD5Rs","bulletPointContainer":"styles_bulletPointContainer__VfdG9"};